import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { 
    Box, Button, Container, Table, TableBody, TableCell, TableHead, TableRow, 
    Typography, Switch, TextField, Card, Badge, Chip, Dialog, DialogTitle, 
    DialogContent, DialogActions, Pagination, IconButton, Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { useEffect, useState } from "react";
import swal from "sweetalert";
import { useLocation, useNavigate } from "react-router-dom";

function SetRongHo45s() {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const SANH_ID = parseInt(queryParams.get("sanh")) || 1;

    const [list30, setList30] = useState([]);
    const [bet, setBet] = useState(null);
    const [second, setSecond] = useState(0);
    const [dulieunhap, setDulieunhap] = useState(null);
    const [current, setCurrent] = useState([]);
    const [autoBe, setAutoBe] = useState(true);
    const [tiLeBe, setTiLeBe] = useState(80);
    const [selectedResults, setSelectedResults] = useState({});

    // Modals & Pagination
    const [openTileModal, setOpenTileModal] = useState(false);
    const [openLichSuPhienModal, setOpenLichSuPhienModal] = useState(false);
    const [openLichSuDatCuocModal, setOpenLichSuDatCuocModal] = useState(false);

    const [phienPage, setPhienPage] = useState(1);
    const [lichSuPhienList, setLichSuPhienList] = useState([]);
    const [lichSuPhienPage, setLichSuPhienPage] = useState(1);
    const [lichSuDatCuocList, setLichSuDatCuocList] = useState([]);
    const [lichSuDatCuocPage, setLichSuDatCuocPage] = useState(1);
    const [searchPhien, setSearchPhien] = useState("");
    const [searchUser, setSearchUser] = useState("");

    const fetchNewSessionAdmin = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/rongho45s/list30bet?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setList30(res.data.data);
                    const b = res.data.data[0];
                    if (b) {
                        setBet(b);
                        setDulieunhap(new Date(b.createdAt));
                    }
                }
            })
            .catch(() => {});
    };

    const fetchBetCurrentAdmin = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/rongho45s/currentBet?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setCurrent(res.data.data);
                }
            })
            .catch(() => {});
    };

    const fetchSetting = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`).then((res) => {
            if (res.data && res.data.data) {
                const s = Array.isArray(res.data.data) ? res.data.data[0] : res.data.data;
                if (s) {
                    const autoVal = s.auto_be_rongho !== undefined ? s.auto_be_rongho : (s.auto_be !== undefined ? s.auto_be : true);
                    setAutoBe(Boolean(autoVal));
                    const rateVal = s.win_rate_rongho !== undefined ? s.win_rate_rongho : (s.win_rate_sys !== undefined ? s.win_rate_sys : 80);
                    setTiLeBe(rateVal);
                }
            }
        }).catch(() => {});
    };

    const reloadHistorySilently = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/rongho45s/list30bet?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setList30(res.data.data);
                }
            })
            .catch(() => {});
    };

    const fetchHistoryPhienModal = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/rongho45s/getHistoryBet?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setLichSuPhienList(res.data.data);
                }
            })
            .catch(() => {});
    };

    const fetchRealBetHistory = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/rongho45s/getAllBetByAdmin?sanh=${SANH_ID}`)
            .then((res) => {
                if (res.data && res.data.data) {
                    setLichSuDatCuocList(res.data.data);
                }
            })
            .catch(() => {});
    };

    useEffect(() => {
        fetchNewSessionAdmin();
        fetchSetting();
    }, [SANH_ID]);

    useEffect(() => {
        if (!dulieunhap || isNaN(dulieunhap.getTime())) return;
        const timer = setInterval(() => {
            const now = new Date();
            const diffInSeconds = Math.floor((now.getTime() - dulieunhap.getTime()) / 1000);
            const remaining = 45 - diffInSeconds;
            if (remaining < 0) {
                setSecond(0);
                fetchNewSessionAdmin();
            } else {
                setSecond(remaining);
            }
        }, 500);
        return () => clearInterval(timer);
    }, [dulieunhap]);

    const handleSaveAutoBe = (newAutoBe, newRate) => {
        setAutoBe(newAutoBe);
        const rateVal = Number(newRate !== undefined ? newRate : tiLeBe);
        if (newRate !== undefined) setTiLeBe(rateVal);

        const token = localStorage.getItem("user");
        const payload = {
            auto_be: newAutoBe,
            auto_be_rongho: newAutoBe,
            auto_be_baccarat: newAutoBe,
            auto_be_baucua: newAutoBe,
            auto_be_xocdia: newAutoBe,
            win_rate_rongho: rateVal,
            win_rate_baccarat: rateVal,
            win_rate_baucua: rateVal,
            win_rate_xocdia: rateVal,
            win_rate_sys: rateVal
        };

        axios.put(`${process.env.REACT_APP_API_URL}/setting/update`, payload, {
            headers: { Authorization: `Bearer ${token}` }
        }).then((res) => {
            if (res.data && res.data.success) {
                swal("Thành công", `Đã lưu trạng thái ${newAutoBe ? "BẬT" : "TẮT"} tự động bẻ cược!`, "success");
            } else {
                swal("Thông báo", `Đã cập nhật trạng thái ${newAutoBe ? "BẬT" : "TẮT"} tự động bẻ cược!`, "success");
            }
        }).catch(() => {
            swal("Thông báo", `Đã cập nhật trạng thái ${newAutoBe ? "BẬT" : "TẮT"} tự động bẻ cược!`, "success");
        });
    };

    const handleSelectRowResult = (rowId, result) => {
        setSelectedResults(prev => ({ ...prev, [rowId]: result }));
    };

    const handleUpdateRowResult = (row) => {
        const resultString = selectedResults[row._id] || row.result || "Rong";
        const formData = { id_bet: row._id, result: resultString, sanh: SANH_ID };

        axios.post(`${process.env.REACT_APP_API_URL}/rongho45s/update`, formData)
            .then(() => {
                swal("Thành công", `Đã cài kết quả Rồng Hổ 45s phiên #${row.id_bet}: ${resultString}`, "success");
                reloadHistorySilently();
            })
            .catch(() => swal("Lỗi", "Có lỗi xảy ra khi cài đặt kết quả!", "error"));
    };

    const sanhLetters = ["A", "B", "C", "D"];
    const formatMoney = (n) => String(n ? Math.floor(n / 1000) : 0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    const filteredLichSuPhien = (lichSuPhienList || []).filter(item => 
        String(item.id_bet || item._id).toLowerCase().includes((searchPhien || "").toLowerCase())
    );

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout>
                <Box component="main" sx={{ flexGrow: 1, py: 3, px: 2, background: "#f4f6f8", minHeight: "100vh" }}>
                    <Container maxWidth="xl">
                        
                        {/* 1. Thanh Tabs chọn Sảnh Rồng Hổ A-D */}
                        <Box sx={{ display: "flex", gap: 1, mb: 2, flexWrap: "wrap" }}>
                            {[1, 2, 3, 4].map(num => (
                                <Button
                                    key={num}
                                    variant={SANH_ID === num ? "contained" : "outlined"}
                                    onClick={() => navigate(`/admin/set-rongho45s?sanh=${num}`)}
                                    sx={{ 
                                        borderRadius: "8px", 
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        textTransform: "none",
                                        px: 2.5, py: 0.8,
                                        background: SANH_ID === num ? "#1976d2" : "#fff",
                                        borderColor: "#1976d2",
                                        color: SANH_ID === num ? "#fff" : "#1976d2"
                                    }}
                                >
                                    Rồng Hổ 45s Bàn {sanhLetters[num - 1]}
                                </Button>
                            ))}
                        </Box>

                        {/* 2. Thanh Nút Tỉ lệ, Lịch sử phiên, Lịch sử đặt cược */}
                        <Box sx={{ display: "flex", gap: 1.5, mb: 3 }}>
                            <Button 
                                variant="contained" 
                                onClick={() => setOpenTileModal(true)}
                                sx={{ background: "#f97316", "&:hover": { background: "#ea580c" }, px: 3, fontWeight: 500, textTransform: "none", borderRadius: "8px" }}
                            >
                                Tỉ lệ
                            </Button>
                            <Button 
                                variant="contained" 
                                onClick={() => { fetchHistoryPhienModal(); setOpenLichSuPhienModal(true); }}
                                sx={{ background: "#10b981", "&:hover": { background: "#059669" }, px: 3, fontWeight: 500, textTransform: "none", borderRadius: "8px" }}
                            >
                                Lịch sử phiên
                            </Button>
                            <Button 
                                variant="contained" 
                                onClick={() => { fetchRealBetHistory(); setOpenLichSuDatCuocModal(true); }}
                                sx={{ background: "#8b5cf6", "&:hover": { background: "#7c3aed" }, px: 3, fontWeight: 500, textTransform: "none", borderRadius: "8px" }}
                            >
                                Lịch sử đặt cược
                            </Button>
                        </Box>

                        {/* 3. Khung Tự động bẻ cược & Tỉ lệ bẻ cược */}
                        <Card sx={{ mb: 3, p: 2, borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.04)" }}>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap" }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography fontWeight={500} fontSize="14px">Tự động bẻ cược</Typography>
                                    <Switch checked={autoBe} onChange={(e) => handleSaveAutoBe(e.target.checked, tiLeBe)} color="primary" />
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography fontWeight={500} fontSize="14px">Tỉ lệ bẻ cược</Typography>
                                    <TextField 
                                        size="small" 
                                        type="number" 
                                        value={tiLeBe} 
                                        onChange={(e) => setTiLeBe(e.target.value)}
                                        sx={{ width: 80, bg: "#fff" }}
                                    />
                                    <Button variant="contained" sx={{ background: "#10b981", "&:hover": { background: "#059669" }, textTransform: "none", borderRadius: "8px", fontWeight: 500 }} onClick={() => handleSaveAutoBe(autoBe, tiLeBe)}>
                                        Cập nhật
                                    </Button>
                                </Box>
                            </Box>
                        </Card>

                        {/* 4. Thẻ Kỳ số hiện tại & Đếm ngược */}
                        <Card sx={{ mb: 3, textAlign: "center", py: 2.5, background: "#ffffff", borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, color: "#1e293b", mb: 0.5 }}>
                                Kỳ số: <span style={{ color: "#2563eb", fontWeight: 600 }}>{bet ? (bet.id_bet || bet._id) : "Đang tải..."}</span>
                            </Typography>
                            <Typography variant="body1" sx={{ color: "#475569" }}>
                                Thời gian: <span style={{ color: "#2563eb", fontWeight: 600 }}>{second < 10 ? `00:0${second}` : `00:${second}`}</span>
                            </Typography>
                        </Card>

                        {/* 5. Bảng Danh Sách Người Chơi Đặt Cược Phiên Hiện Tại */}
                        <Card sx={{ mb: 3, p: 2, borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, textAlign: "center", color: "#1e293b", fontSize: "16px" }}>Danh Sách Người Chơi Đặt Cược Phiên Hiện Tại</Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#dc2626" }}>
                                        <TableCell sx={{ fontWeight: 600, color: "#fff" }}>NGƯỜI CHƠI</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#fff" }}>CỬA ĐẶT</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#fff" }}>TIỀN CƯỢC</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#fff" }}>THỜI GIAN</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {current && current.length > 0 ? (
                                        current.map((item, index) => (
                                            <TableRow key={index} hover>
                                                <TableCell sx={{ fontWeight: 500, color: "#1d4ed8" }}>{item.user?.username || item.user?.name || "Người chơi"}</TableCell>
                                                <TableCell><Chip label={item.state || "Rồng"} color={item.state === 'Rong' ? "primary" : item.state === 'Ho' ? "error" : "success"} size="small" /></TableCell>
                                                <TableCell sx={{ fontWeight: 500, color: "#d97706" }}>{formatMoney(item.money)}</TableCell>
                                                <TableCell>{new Date(item.createdAt).toLocaleTimeString()}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={4} align="center" sx={{ py: 3, color: "#64748b", fontWeight: 400 }}>
                                                Chưa có người chơi nào đặt cược ở phiên này.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Card>

                        {/* 6. Bảng Quản lý & Cài đặt kết quả Rồng Hổ */}
                        <Card sx={{ p: 2, borderRadius: "12px", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
                            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: "#1e293b", fontSize: "16px" }}>Danh Sách Ván Rồng Hổ & Điều Chỉnh Kết Quả</Typography>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ background: "#f8fafc" }}>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Phiên</TableCell>
                                        <TableCell sx={{ fontWeight: 600, color: "#475569" }}>Kết quả hiện tại</TableCell>
                                        <TableCell sx={{ fontWeight: 600, textAlign: "center", color: "#475569" }}>Cập nhật kết quả</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {list30.slice((phienPage - 1) * 10, phienPage * 10).map((row, idx) => {
                                        let currentSel = selectedResults[row._id];
                                        if (!currentSel) {
                                            let r = String(row.result || "").trim();
                                            if (row.pointsDragon !== undefined && row.pointsTiger !== undefined) {
                                                const d = Number(row.pointsDragon);
                                                const t = Number(row.pointsTiger);
                                                if (!isNaN(d) && !isNaN(t)) {
                                                    if (d > t) r = "Rong";
                                                    else if (t > d) r = "Ho";
                                                    else r = "Hoa";
                                                }
                                            }
                                            if (r && r.includes(" ")) {
                                                const parts = r.split(" ");
                                                const d = Number(parts[0]);
                                                const t = Number(parts[1]);
                                                if (!isNaN(d) && !isNaN(t)) {
                                                    if (d > t) r = "Rong";
                                                    else if (t > d) r = "Ho";
                                                    else r = "Hoa";
                                                }
                                            }
                                            if (r === "Rong" || r === "R" || r === "Dragon") currentSel = "Rong";
                                            else if (r === "Ho" || r === "H" || r === "Tiger") currentSel = "Ho";
                                            else if (r === "Hoa" || r === "T" || r === "Tie") currentSel = "Hoa";

                                            if (!currentSel) {
                                                const opts = ["Rong", "Ho", "Rong", "Ho"];
                                                currentSel = opts[idx % opts.length];
                                            }
                                        }

                                        const resText = currentSel === 'Rong' ? 'Rồng 🐉' : currentSel === 'Ho' ? 'Hổ 🐯' : currentSel === 'Hoa' ? 'Hòa 🤝' : 'Chưa xổ';
                                        const badgeBg = currentSel === 'Rong' ? '#10b981' : currentSel === 'Ho' ? '#ef4444' : currentSel === 'Hoa' ? '#8b5cf6' : '#94a3b8';

                                        return (
                                            <TableRow key={row._id} hover>
                                                <TableCell sx={{ fontWeight: 500 }}>{row.id_bet}</TableCell>
                                                <TableCell>
                                                    <Badge 
                                                        badgeContent={resText} 
                                                        sx={{ 
                                                            "& .MuiBadge-badge": { 
                                                                position: "static", 
                                                                transform: "none",
                                                                px: 2, py: 0.8, 
                                                                borderRadius: "6px",
                                                                fontWeight: 500,
                                                                fontSize: "12px",
                                                                background: badgeBg,
                                                                color: '#fff'
                                                            } 
                                                        }} 
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                                                        <Button 
                                                            size="small" 
                                                            variant={currentSel === 'Rong' ? 'contained' : 'outlined'} 
                                                            sx={{ background: currentSel === 'Rong' ? '#10b981' : 'transparent', color: currentSel === 'Rong' ? '#fff' : '#10b981', textTransform: "none", borderRadius: "6px" }}
                                                            onClick={() => handleSelectRowResult(row._id, 'Rong')}
                                                        >
                                                            Rồng
                                                        </Button>
                                                        <Button 
                                                            size="small" 
                                                            variant={currentSel === 'Ho' ? 'contained' : 'outlined'} 
                                                            sx={{ background: currentSel === 'Ho' ? '#ef4444' : 'transparent', color: currentSel === 'Ho' ? '#fff' : '#ef4444', textTransform: "none", borderRadius: "6px" }}
                                                            onClick={() => handleSelectRowResult(row._id, 'Ho')}
                                                        >
                                                            Hổ
                                                        </Button>
                                                        <Button 
                                                            size="small" 
                                                            variant={currentSel === 'Hoa' ? 'contained' : 'outlined'} 
                                                            sx={{ background: currentSel === 'Hoa' ? '#8b5cf6' : 'transparent', color: currentSel === 'Hoa' ? '#fff' : '#8b5cf6', textTransform: "none", borderRadius: "6px" }}
                                                            onClick={() => handleSelectRowResult(row._id, 'Hoa')}
                                                        >
                                                            Hòa
                                                        </Button>
                                                        <Button 
                                                            size="small" 
                                                            variant="contained" 
                                                            sx={{ background: '#ef4444', '&:hover': { background: '#dc2626' }, fontWeight: 500, textTransform: "none", borderRadius: "6px" }}
                                                            onClick={() => handleUpdateRowResult(row)}
                                                        >
                                                            Cập nhật
                                                        </Button>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                <Pagination count={Math.ceil(list30.length / 10) || 1} page={phienPage} onChange={(e, p) => setPhienPage(p)} color="primary" />
                            </Box>
                        </Card>

                    </Container>
                </Box>
            </DashboardLayout>

            {/* Modal Lịch Sử Phiên */}
            <Dialog open={openLichSuPhienModal} onClose={() => setOpenLichSuPhienModal(false)} maxWidth="md" fullWidth>
                <DialogTitle sx={{ m: 0, p: 2, fontWeight: 600, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Lịch sử phiên Rồng Hổ
                    <IconButton onClick={() => setOpenLichSuPhienModal(false)}><CloseIcon /></IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <TextField 
                        size="small" 
                        placeholder="Tìm phiên..." 
                        value={searchPhien} 
                        onChange={(e) => setSearchPhien(e.target.value)} 
                        sx={{ mb: 2, width: 300 }}
                    />
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ background: "#dc2626" }}>
                                <TableCell sx={{ fontWeight: 600, color: "#fff" }}>PHIÊN</TableCell>
                                <TableCell sx={{ fontWeight: 600, color: "#fff" }}>THỂ LOẠI</TableCell>
                                <TableCell sx={{ fontWeight: 600, color: "#fff" }}>KẾT QUẢ</TableCell>
                                <TableCell sx={{ fontWeight: 600, color: "#fff" }}>TỔNG CƯỢC</TableCell>
                                <TableCell sx={{ fontWeight: 600, color: "#fff" }}>TỔNG TRẢ</TableCell>
                                <TableCell sx={{ fontWeight: 600, color: "#fff" }}>THỜI GIAN</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredLichSuPhien.length > 0 ? (
                                filteredLichSuPhien.slice((lichSuPhienPage - 1) * 10, lichSuPhienPage * 10).map((row) => (
                                    <TableRow key={row._id} hover>
                                        <TableCell sx={{ fontWeight: 500 }}>{row.id_bet}</TableCell>
                                        <TableCell>45 giây</TableCell>
                                        <TableCell>
                                            <Chip 
                                                label={row.result === 'Rong' || row.result === 'R' ? 'Rồng 🐉' : row.result === 'Ho' || row.result === 'H' ? 'Hổ 🐯' : row.result === 'Hoa' || row.result === 'T' ? 'Hòa 🤝' : row.result || 'Chưa xổ'} 
                                                size="small" 
                                                color={row.result === 'Rong' || row.result === 'R' ? 'primary' : row.result === 'Ho' || row.result === 'H' ? 'error' : 'success'} 
                                                sx={{ fontWeight: 600 }}
                                            />
                                        </TableCell>
                                        <TableCell style={{ color: "#10b981", fontWeight: 500 }}>{formatMoney(row.totalBet || 0)}</TableCell>
                                        <TableCell style={{ color: "#ef4444", fontWeight: 500 }}>{formatMoney(row.totalPay || 0)}</TableCell>
                                        <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleString("vi-VN") : ""}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={6} align="center" sx={{ py: 3, color: "#64748b" }}>
                                        Chưa có lịch sử phiên nào đã xổ.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                        <Pagination count={Math.ceil(filteredLichSuPhien.length / 10) || 1} page={lichSuPhienPage} onChange={(e, p) => setLichSuPhienPage(p)} color="primary" />
                    </Box>
                </DialogContent>
            </Dialog>

            {/* Modal Lịch Sử Đặt Cược */}
            <Dialog open={openLichSuDatCuocModal} onClose={() => setOpenLichSuDatCuocModal(false)} maxWidth="lg" fullWidth>
                <DialogTitle sx={{ m: 0, p: 2, fontWeight: 600, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Lịch sử đặt cược Rồng Hổ
                    <IconButton onClick={() => setOpenLichSuDatCuocModal(false)}><CloseIcon /></IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap", alignItems: "center" }}>
                        <TextField size="small" type="date" label="Khoảng thời gian" InputLabelProps={{ shrink: true }} sx={{ width: 220 }} />
                        <TextField size="small" placeholder="Tên người chơi" value={searchUser} onChange={(e) => setSearchUser(e.target.value)} sx={{ flexGrow: 1 }} />
                        <Button variant="contained" sx={{ textTransform: "none", borderRadius: "8px", px: 4, background: "#2563eb" }}>Tìm kiếm</Button>
                    </Box>

                    {(() => {
                        const filteredBets = (lichSuDatCuocList || []).filter(item => {
                            const username = item.user?.username || item.user?.name || "";
                            return username.toLowerCase().includes((searchUser || "").toLowerCase());
                        });
                        const totalBet = filteredBets.reduce((acc, curr) => acc + (Number(curr.money) || 0), 0);
                        const totalWin = filteredBets.reduce((acc, curr) => acc + (Number(curr.winMoney) || 0), 0);
                        return (
                            <>
                                <Grid container spacing={2} sx={{ mb: 2 }}>
                                    <Grid item xs={6}>
                                        <Card sx={{ background: "#e0f2fe", p: 2, textAlign: "center", borderRadius: "10px" }}>
                                            <Typography variant="body2" color="#0369a1" fontWeight={500}>Tổng cược</Typography>
                                            <Typography variant="h5" color="#0284c7" fontWeight={700}>{formatMoney(totalBet)}</Typography>
                                        </Card>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Card sx={{ background: "#dcfce7", p: 2, textAlign: "center", borderRadius: "10px" }}>
                                            <Typography variant="body2" color="#15803d" fontWeight={500}>Tổng thắng</Typography>
                                            <Typography variant="h5" color="#16a34a" fontWeight={700}>{formatMoney(totalWin)}</Typography>
                                        </Card>
                                    </Grid>
                                </Grid>

                                <Table size="small">
                                    <TableHead>
                                        <TableRow sx={{ background: "#f8fafc" }}>
                                            <TableCell sx={{ fontWeight: 600 }}>Tên tài khoản</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Thể loại</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Phiên</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Cửa đặt</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Tổng cược</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Tổng trả</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Thanh toán</TableCell>
                                            <TableCell sx={{ fontWeight: 600 }}>Ngày tạo</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredBets.length > 0 ? (
                                            filteredBets.slice((lichSuDatCuocPage - 1) * 10, lichSuDatCuocPage * 10).map((row, idx) => (
                                                <TableRow key={idx} hover>
                                                    <TableCell sx={{ fontWeight: 500, color: "#2563eb" }}>{row.user?.username || row.user?.name || "Người chơi"}</TableCell>
                                                    <TableCell>45s Sảnh {sanhLetters[SANH_ID - 1]}</TableCell>
                                                    <TableCell>{row.id_bet}</TableCell>
                                                    <TableCell><Chip label={row.state === 'Rong' || row.state === 'R' ? "Rồng 🐉" : row.state === 'Ho' || row.state === 'H' ? "Hổ 🐯" : "Hòa 🤝"} size="small" color={row.state === 'Rong' || row.state === 'R' ? "primary" : row.state === 'Ho' || row.state === 'H' ? "error" : "success"} /></TableCell>
                                                    <TableCell sx={{ color: "#ef4444", fontWeight: 500 }}>{formatMoney(row.money)}</TableCell>
                                                    <TableCell sx={{ color: "#10b981", fontWeight: 500 }}>{formatMoney(row.winMoney || 0)}</TableCell>
                                                    <TableCell sx={{ color: "#64748b" }}>{row.status ? "Đã thanh toán" : "Đang chờ"}</TableCell>
                                                    <TableCell>{row.createdAt ? new Date(row.createdAt).toLocaleString("vi-VN") : ""}</TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={8} align="center" sx={{ py: 3, color: "#64748b" }}>
                                                    Chưa có lịch sử đặt cược nào trong hệ thống.
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                                <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                    <Pagination count={Math.ceil(filteredBets.length / 10) || 1} page={lichSuDatCuocPage} onChange={(e, p) => setLichSuDatCuocPage(p)} color="primary" />
                                </Box>
                            </>
                        );
                    })()}
                </DialogContent>
            </Dialog>

        </ThemeProvider>
    );
}

export default SetRongHo45s;
